// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3wSIO","noInteraction":"EventWrapper_noInteraction__hDBlw","pointerPassthrough":"EventWrapper_pointerPassthrough__2noqv"};